/**
 * Get the base URL of the application
 * Uses environment variable or falls back to current window location
 */
export const getBaseUrl = () => {
  // Check if we're in browser environment
  if (typeof window !== 'undefined') {
    // Use environment variable if available
    if (process.env.REACT_APP_SITE_URL) {
      return process.env.REACT_APP_SITE_URL;
    }
    // Otherwise use current location
    const { protocol, hostname, port } = window.location;
    const portString = port ? `:${port}` : '';
    return `${protocol}//${hostname}${portString}`;
  }
  
  // Fallback for server-side rendering or build time
  return process.env.REACT_APP_SITE_URL || 'https://vithminds.com';
};

/**
 * Get full URL for a path
 * @param {string} path - Path to append to base URL (e.g., '/about-us')
 */
export const getFullUrl = (path = '') => {
  const baseUrl = getBaseUrl();
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

/**
 * Get current canonical URL
 */
export const getCanonicalUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.href;
  }
  return getBaseUrl();
};

const config = {
  getBaseUrl,
  getFullUrl,
  getCanonicalUrl
};

export default config;
